import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

export async function exportToPDF(element: HTMLElement | null) {
  if (!element) throw new Error('Elemento não encontrado')

  const sections = element.querySelectorAll('section')
  const pdf = new jsPDF('p', 'mm', 'a4')
  const pageWidth = pdf.internal.pageSize.getWidth()
  const pageHeight = pdf.internal.pageSize.getHeight()
  const margin = 10

  for (let i = 0; i < sections.length; i++) {
    const section = sections[i] as HTMLElement
    const canvas = await html2canvas(section, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
    })

    const imgData = canvas.toDataURL('image/png')
    const imgWidth = pageWidth - margin * 2
    const imgHeight = (canvas.height * imgWidth) / canvas.width

    if (i > 0) pdf.addPage()

    let position = margin
    let heightLeft = imgHeight

    if (imgHeight <= pageHeight - margin * 2) {
      pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight)
    } else {
      // Multi-page if section taller than page
      pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight)
      heightLeft -= pageHeight - margin * 2
      while (heightLeft > 0) {
        position = heightLeft - imgHeight + margin
        pdf.addPage()
        pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight)
        heightLeft -= pageHeight - margin * 2
      }
    }
  }

  pdf.save('Apresentacao_Indicadores_PCDF_Teltronic.pdf')
}
